<template>
  <b-container>
    <b-form-group :disabled="changes_disabled">
      <communicating-tables-lists
        :brick_id="brick_id"
        :rhs_title="$t('list_aggregating_tables')"
        :all_tables="tables_undeleted"
        :rhs_elements="aggregated_tables"
        :element_constructor="rhs_table_structure"
        :disabled="changes_disabled"
        @input="maj($event)"
      >
        <template v-slot:rhs_table_component="slot_props">
          <b-list-group-item class="table-handle hand-pointer">
            <span class="fas fa-fw fa-grip-vertical" />
            <span> {{ slot_props.element_name }} </span>
          </b-list-group-item>
        </template>
      </communicating-tables-lists>
      <b-card class="mt-3" :header="$t('jointure_table')">
        <b-form-select
          v-model="selected_joining_table"
          :options="joinable_tables_options_by_uid"
        />
      </b-card>

      <!--       <b-card v-if="brick_id" class="mt-3" :header="$t('auto_relations')">
        <p v-if="_.isEmpty(automatic_relations)" class="text-center">
          {{ $t('no_current_relations') }}
        </p>

        <div v-else>
          <brick-aggregation-subcomponent-relation-edition
            v-for="(relation, index) in automatic_relations"
            :key="JSON.stringify(relation)"
            :relation="relation"
            :project_id="project_id"
            :possible_tables_options="joinable_tables_options_by_name"
            :uid_from_name_func="get_table_uid_from_name"
            :relation_type_options="relation_type_options"
            @deleted="delete_relation(index)"
            @validate="validate_relation($event, index)"
          />
        </div>
      </b-card> -->

      <!--       <b-card v-if="brick_id" class="mt-3" :header="$t('auto_relations')">
        <p v-if="_.isEmpty(automatic_relations)" class="text-center">
          {{ $t('no_current_relations') }}
        </p>

        <div v-else>
          <brick-aggregation-subcomponent-relation-edition
            v-for="(relation, index) in automatic_relations"
            :key="JSON.stringify(relation)"
            :relation="relation"
            :project_id="project_id"
            :possible_tables_options="joinable_tables_options_by_name"
            :uid_from_name_func="get_table_uid_from_name"
            :relation_type_options="relation_type_options"
            @deleted="delete_relation(index)"
            @validate="validate_relation($event, index)"
          />
        </div>
      </b-card> -->

      <unroll-element :title="$t('auto_relations')" :available="true">
        <unroll-element
          v-for="(metavariables_dict_poid, index) in metavariables_dicts_poids"
          :title="stringified_dict(metavariables_dict_poid)"
          :available="true"
        >
          <p
            v-if="_.isEmpty(metavariables_dicts_automatic_relations[index])"
            class="text-center"
          >
            {{ $t('no_current_relations') }}
          </p>

          <div v-else>
            <brick-aggregation-subcomponent-relation-edition
              v-for="(relation,
              sub_index) in metavariables_dicts_automatic_relations[index]"
              :key="JSON.stringify(relation)"
              :relation="relation"
              :project_id="project_id"
              :possible_tables_options="joinable_tables_options_by_name"
              :uid_from_name_func="get_table_uid_from_name"
              :relation_type_options="relation_type_options"
            />
          </div>
        </unroll-element>
      </unroll-element>

      <b-card v-if="brick_id" class="mt-3" :header="$t('delta_relations')">
        <p v-if="_.isEmpty(delta_relations)" class="text-center">
          {{ $t('no_current_relations') }}
        </p>

        <div v-else>
          <brick-aggregation-subcomponent-relation-edition
            v-for="(relation, index) in delta_relations"
            :key="JSON.stringify(relation)"
            :relation="relation.relation"
            :delta_mode="relation.delta_mode"
            :project_id="project_id"
            :possible_tables_options="joinable_tables_options_by_name"
            :relation_type_options="relation_type_options"
            :uid_from_name_func="get_table_uid_from_name"
            @deleted="delete_relation(index)"
            @validate="validate_relation($event, index)"
            @changed_delta_mode="changed_delta_mode($event, index)"
          />
        </div>
      </b-card>

      <!--       <b-card v-if="brick_id" class="mt-3" :header="$t('total_relations')">
        <p v-if="_.isEmpty(corrected_relations)" class="text-center">
          {{ $t('no_current_relations') }}
        </p>

        <div v-else>
          <brick-aggregation-subcomponent-relation-edition
            v-for="(relation, index) in corrected_relations"
            :key="JSON.stringify(relation)"
            :relation="relation"
            :project_id="project_id"
            :possible_tables_options="joinable_tables_options_by_name"
            :relation_type_options="relation_type_options"
            :uid_from_name_func="get_table_uid_from_name"
            @deleted="delete_relation(index)"
            @validate="validate_relation($event, index)"
          />
        </div>
      </b-card> -->

      <unroll-element :title="$t('total_relations')" :available="true">
        <unroll-element
          v-for="(metavariables_dict_poid, index) in metavariables_dicts_poids"
          :title="stringified_dict(metavariables_dict_poid)"
          :available="true"
        >
          <p
            v-if="_.isEmpty(metavariables_dicts_corrected_relations[index])"
            class="text-center"
          >
            {{ $t('no_current_relations') }}
          </p>

          <div v-else>
            <brick-aggregation-subcomponent-relation-edition
              v-for="(relation,
              sub_index) in metavariables_dicts_corrected_relations[index]"
              :key="JSON.stringify(relation)"
              :relation="relation"
              :project_id="project_id"
              :possible_tables_options="joinable_tables_options_by_name"
              :uid_from_name_func="get_table_uid_from_name"
              :relation_type_options="relation_type_options"
            />
          </div>
        </unroll-element>
      </unroll-element>

      <b-card class="mt-3" :header="$t('new_relation')">
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group>
              <label>
                <b> {{ $t('left_table') }} </b>
              </label>
              <b-form-select
                v-model="selected_relation.relation.lhs_table_name"
                :options="joinable_tables_options_by_name"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group>
              <label>
                <b> {{ $t('right_table') }} </b>
              </label>
              <b-form-select
                v-model="selected_relation.relation.rhs_table_name"
                :options="joinable_tables_options_by_name"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="current_delta_mode !== 'substract'">
          <b-col md="4" lg="5" />
          <b-col cols="12" md="4" lg="2">
            <b-form-group>
              <label>
                <b> {{ $t('relation_type') }} </b>
              </label>
              <b-form-select
                v-model="selected_relation.relation.relation_type"
                :options="relation_type_options"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="current_delta_mode !== 'substract'">
          <b-col cols="12" md="6">
            <columns-choice-options
              v-model="selected_relation.relation.id_columns_lhs"
              :main_text="$t('left_table_id_cols')"
              :available_column_names="columns_lhs"
            >
              <template #sub_component="props">
                <generic-column-name-edition
                  v-bind="props"
                  v-on="props.listeners"
                />
              </template>
            </columns-choice-options>
          </b-col>

          <b-col cols="12" md="6">
            <columns-choice-options
              v-model="selected_relation.relation.id_columns_rhs"
              :main_text="$t('right_table_id_cols')"
              :available_column_names="columns_rhs"
            >
              <template #sub_component="props">
                <generic-column-name-edition
                  v-bind="props"
                  v-on="props.listeners"
                />
              </template>
            </columns-choice-options>
          </b-col>
        </b-row>

        <b-dropdown
          split
          :text="
            current_delta_mode === 'add'
              ? $t('add_current_relation')
              : $t('substract_current_relation')
          "
          :variant="
            current_delta_mode === 'add' ? 'outline-success' : 'outline-danger'
          "
          class="mt-3"
          @click="add_relation(current_delta_mode)"
        >
          <b-dropdown-item @click="current_delta_mode = 'add'"
            >Add</b-dropdown-item
          >
          <b-dropdown-item @click="current_delta_mode = 'substract'"
            >Substract</b-dropdown-item
          >
        </b-dropdown>

        <b-alert
          :show="dismiss_count_down"
          class="mt-4 mb-0"
          dismissible
          variant="warning"
          @dismissed="dismiss_count_down = 0"
          @dismiss-count-down="count_down_changed"
        >
          {{ $t('incomplete_relation') }}
        </b-alert>
      </b-card>
    </b-form-group>
  </b-container>
</template>

<i18n>
{
  "en": {
    "list_aggregating_tables": "List of tables to aggregate",
    "jointure_table": "Table to join on",
    "new_relation": "New relation",
    "left_table": "Left table (Main)",
    "right_table": "Right table",
    "relation_type": "Relation type",
    "left_table_id_cols": "Left table id columns",
    "right_table_id_cols": "Right table id columns",
    "incomplete_relation": "Incomplete relation",
    "add_current_relation": "Add this relation",
    "substract_current_relation": "Substract this relation",
    "no_current_relations": "No relations added",
    "current_relations": "Current relations",
    "auto_relations": "Automatically detected relations",
    "delta_relations": "Relations adjustment",
    "total_relations": "Final relations"
  },
  "fr": {
    "list_aggregating_tables": "Liste des tables à agréger",
    "jointure_table": "Table de jointure",
    "new_relation": "Nouvelle relation",
    "left_table": "Table de gauche (Principale)",
    "right_table": "Table de droite",
    "relation_type": "Relation",
    "left_table_id_cols": "Colonnes d'id pour la table de gauche",
    "right_table_id_cols": "Colonnes d'id pour la table de droite",
    "incomplete_relation": "Relation incomplète",
    "add_current_relation": "Ajouter cette relation",
    "substract_current_relation": "Enlever cette relation",
    "no_current_relations": "Pas de relations définies",
    "current_relations": "Relations actuelles",
    "auto_relations": "Relations détectées automatiquement",
    "delta_relations": "Ajustement des relations",
    "total_relations": "Relations finales"
  }
}
</i18n>

<script>
import _ from 'lodash'
import Vue from 'vue'

import { table_columns } from '@/api/subscriptions.js'
import {
  AutomlSingleRelation,
  AutomlRelationDelta,
  BasicTableInfoEntity,
} from '@/components/object_model.js'

import { global_brick_mixin } from '@/components/mixin.js'
import UnrollElement from './unroll_element.vue'
import ColumnsChoiceOptions from './columns_choice_options.vue'
import CommunicatingTablesLists from '@/components/communicating_tables_lists.vue'
import GenericColumnNameEdition from '@/components/generic_column_name_edition.vue'
import BrickAggregationSubcomponentRelationEdition from '@/components/brick_aggregation_subcomponent_relation_edition.vue'

// *****************************************************************************

export default {
  name: 'BrickAggregation',
  components: {
    UnrollElement,
    BrickAggregationSubcomponentRelationEdition,
    ColumnsChoiceOptions,
    GenericColumnNameEdition,
    CommunicatingTablesLists,
  },
  mixins: [global_brick_mixin],
  data() {
    return {
      rhs_table_structure: BasicTableInfoEntity,
      aggregated_tables: [],

      selected_joining_table: -1,

      delta_relations: [],
      current_delta_mode: 'add',

      selected_relation: new AutomlRelationDelta(),
      relation_type_options: [
        { value: -1, text: 'Type' },
        { value: 'one_to_one', text: '1 to 1' },
        { value: 'one_to_many', text: '1 to Many' },
        { value: 'many_to_one', text: 'Many to 1' },
      ],
      columns_lhs: [],
      columns_rhs: [],

      dismiss_secs: 5,
      dismiss_count_down: 0,
    }
  },

  computed: {
    adapted_data() {
      let junction_table_name = this.get_table_name_from_uid(
        this.selected_joining_table
      )
      let adapted = {
        uid: this.brick_id,
        parents_info: this.aggregated_tables,
        junction_table_name: junction_table_name,
        relations: _.cloneDeep(this.delta_relations),
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
    _() {
      return _
    },
    joinable_tables_options_by_uid() {
      let self = this
      let res = _.map(this.aggregated_tables, function(elt) {
        return {
          value: elt.uid,
          text: self.tables_undeleted['tables'][elt.uid].name,
        }
      })

      res.push({ value: -1, text: this.$t('choose_a_table') })

      return res
    },
    // automatic_relations() {
    //   const res =
    //     this.fetch_poid_data(
    //       'automatic_relations',
    //       (this.tracking_info || {}).automatic_relationships_poid
    //     ) || []
    //   return res
    // },

    // automatic_coercion_infos() {
    //   let res = _.map(
    //     this.tracking_infos,
    //     tracking_info =>
    //       this.fetch_poid_data(
    //         `automatic_coercion_info_${
    //           (tracking_info || {}).automatic_coercion_info_poid
    //         }`,
    //         (tracking_info || {}).automatic_coercion_info_poid
    //       ) || {}
    //   )
    //   return res
    // },

    metavariables_dicts_automatic_relations() {
      const res = _.map(this.tracking_infos, tracking_info =>
        this.fetch_poid_data(
          `automatic_relations_${
            (tracking_info || {}).automatic_relationships_poid
          }`,
          (tracking_info || {}).automatic_relationships_poid
        )
      )

      return res
    },
    // corrected_relations() {
    //   const res =
    //     this.fetch_poid_data(
    //       'corrected_relations',
    //       (this.tracking_info || {}).corrected_relationships_poid
    //     ) || []
    //   return res
    // },

    metavariables_dicts_corrected_relations() {
      const res = _.map(this.tracking_infos, tracking_info =>
        this.fetch_poid_data(
          `corrected_relations_${
            (tracking_info || {}).corrected_relationships_poid
          }`,
          (tracking_info || {}).corrected_relationships_poid
        )
      )

      return res
    },

    joinable_tables_options_by_name() {
      let self = this
      let res = _.map(this.aggregated_tables, function(elt) {
        let name = self.tables_undeleted['tables'][elt.uid].name
        // N.B PL : There probably is a better way if value/text are the same
        return {
          value: name,
          text: name,
        }
      })

      res.push({ value: '', text: this.$t('choose_a_table') })

      return res
    },
  },

  watch: {
    cur_brick: {
      immediate: true,
      handler(nv, ov) {
        let cur_aggregated_tables = this.cur_brick.parents_info
        if (!_.isEqual(cur_aggregated_tables, this.aggregated_tables)) {
          this.aggregated_tables = _.cloneDeep(cur_aggregated_tables)
        }
        if (
          (!_.isMatchWith(
            nv,
            _.pick(ov || {}, 'junction_table_name relations'.split(' '))
          ),
          _.isEqual)
        ) {
          nv = nv || {}
          let junction_table_id = this.get_table_uid_from_name(
            nv.junction_table_name
          )
          // N.B PL : Why the indirection ?
          if (junction_table_id !== -1) {
            this.selected_joining_table = this.tables_undeleted['tables'][
              junction_table_id
            ].uid
          }
          this.delta_relations = _.cloneDeep(nv.relations)
        }
      },
    },

    'selected_relation.relation.lhs_table_name': async function() {
      let lhs_table_uid = this.get_table_uid_from_name(
        this.selected_relation.relation.lhs_table_name
      )
      this.columns_lhs =
        (await table_columns(this.project_id, lhs_table_uid)).pipe_object || []
    },

    'selected_relation.relation.rhs_table_name': async function() {
      let rhs_table_uid = this.get_table_uid_from_name(
        this.selected_relation.relation.rhs_table_name
      )
      this.columns_rhs =
        (await table_columns(this.project_id, rhs_table_uid)).pipe_object || []
    },
  },
  methods: {
    // N.B PL : Maybe factorize this between
    // reference_table_id / junction_id / table_lhs
    get_table_name_from_uid(uid) {
      let res = ''
      // N.B PL : What to do if uid is not found ?
      if (uid !== -1) {
        res = this.bricks_undeleted['bricks'][uid].name
      }
      return res
    },
    // N.B PL : Maybe factorize this between
    // reference_table_id / junction_id / table_lhs
    get_table_uid_from_name(name) {
      /*
      Here name is the name of a parent table
      */
      let res = -1
      // N.B PL : What to do if name is not found among parent tables
      if (name !== '') {
        for (let info_entity of this.cur_brick.parents_info) {
          let uid = info_entity.uid
          let brick = this.bricks_undeleted['bricks'][uid]
          if (name === brick.name) {
            res = uid
            break
          }
        }
      }
      return res
    },
    maj(event) {
      this.aggregated_tables = _.cloneDeep(event)
    },
    is_selected_relation_incomplete(rel) {
      let res = rel.lhs_table_name === -1 || rel.rhs_table_name === -1
      if (this.current_delta_mode === 'add') {
        res =
          res ||
          _.isEmpty(rel.id_columns_lhs) ||
          _.isEmpty(rel.id_columns_rhs) ||
          rel.relation_type === -1
      }
      return res
    },
    add_relation() {
      if (
        this.is_selected_relation_incomplete(this.selected_relation.relation)
      ) {
        this.dismiss_count_down = this.dismiss_secs
      } else {
        this.selected_relation.delta_mode = this.current_delta_mode
        if (this.current_delta_mode === 'substract') {
          this.selected_relation.relation.id_columns_lhs = []
          this.selected_relation.relation.id_columns_rhs = []
          this.selected_relation.relation.relation_type = -1
        }
        this.delta_relations.push(this.selected_relation)
        this.selected_relation = new AutomlRelationDelta()
      }
    },
    delete_relation(index) {
      this.delta_relations.splice(index, 1)
    },
    validate_relation(data, index) {
      let rel = new AutomlSingleRelation()
      _.assign(rel, data)
      let relation = new AutomlRelationDelta()
      relation.delta_mode = this.delta_relations[index].delta_mode
      relation.relation = rel
      Vue.set(this.delta_relations, index, relation)
    },

    count_down_changed(dismiss_count_down) {
      this.dismiss_count_down = dismiss_count_down
    },

    changed_delta_mode(delta_mode, index) {
      this.delta_relations[index].delta_mode = delta_mode
    },
  },
}
</script>
